// translations.ts
import { BoldTranslations } from "./client/extensions/Bold.js";
import { CommentTranslations } from "./client/extensions/Comment/Comment.js";
import { HeadingTranslations } from "./client/extensions/Heading.js";
import { HighlightTranslations } from "./client/extensions/Highlight.js";
import { HistoryTranslations } from "./client/extensions/History.js";
import { IndentTranslations } from "./client/extensions/Indent/Indent.js";
import { ItalicTranslations } from "./client/extensions/Italic.js";
import { LinkTranslations } from "./client/extensions/Link/Link.js";
import { StrikeTranslations } from "./client/extensions/Strike.js";
import { SuggestTranslations } from "./client/extensions/SuggestEdit.js";
import { TableTranslations } from "./client/extensions/Table.js";
import { TextAlignTranslations } from "./client/extensions/TextAlign.js";
import { UnderlineTranslations } from "./client/extensions/Underline.js";
var tiptapTranslations = {
  tiptap: {
    ...BoldTranslations,
    ...ItalicTranslations,
    ...UnderlineTranslations,
    ...StrikeTranslations,
    ...TextAlignTranslations,
    ...IndentTranslations,
    ...LinkTranslations,
    ...HeadingTranslations,
    ...HighlightTranslations,
    ...TableTranslations,
    ...SuggestTranslations,
    ...CommentTranslations,
    ...HistoryTranslations
  }
};
export {
  tiptapTranslations
};
